import { render, staticRenderFns } from "./TemplateBuilderGroup.vue?vue&type=template&id=9adc4df0&"
import script from "./TemplateBuilderGroup.vue?vue&type=script&lang=js&"
export * from "./TemplateBuilderGroup.vue?vue&type=script&lang=js&"
import style0 from "./TemplateBuilderGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports